// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function ResellerPerformancePEPMRow() {
   const state = useQuoteContext()
   const { getString } = state

   if (state.resellerCustomerQuoteValues.performancePEPM > 0)
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>
               {getString('product.ResellerPerformancePEPMRow.Title')}
            </div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.resellerCustomerQuoteValues.performancePEPM,
                  state.currencyObject,
               )}
            </div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.resellerCustomerQuoteValues.performanceTotalPrice,
                  state.currencyObject,
               )}
            </div>
         </div>
      )
}
